import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { OpendialogAddEditTraineeComponent } from 'app/components/dialog/open-dialog-add-edit-trainee/opendialog-add-edit-trainee.component';
import { Trainee } from 'app/shared/models/class/trainee/trainee';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';

@Component({
  selector: 'app-trainee-overview',
  templateUrl: './trainee-overview.component.html',
  styleUrls: ['./trainee-overview.component.scss']
})
export class TraineeOverviewComponent implements OnInit {
  @Input() trainee: Trainee;
  @Output() isUpdate = new EventEmitter<boolean>();

  constructor(
    private dialog: MatDialog,
    private faIconService: FaiconService,
  ) { }

  ngOnInit(): void { }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  openDialogAddOrEditTrainee(action: string) {
    const dialogRef = this.dialog.open(OpendialogAddEditTraineeComponent, {
      data: { action, trainee: this.trainee },
      minWidth: '50%',
      height: '80%'
    });

    dialogRef.afterClosed().subscribe({
      next: (res) => {
        if (res) {
          this.trainee = res;
          this.isUpdate.emit(true)
        }
      }
    });
  }


}
